var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA2M(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7598_88288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 18.42H0V6.05084L10 0.76532L20 6.05084V18.42ZM1.56707 16.853H18.4303V6.9964L10 2.53956L1.56707 6.9964V16.853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7411 9.26196V11.4824L10.0014 15.2221L6.26172 11.4824V9.26196L9.21789 12.2208V5.74536H10.785V12.2208L13.7411 9.26196Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7598_88288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.6547,
    fill: "white",
    transform: "translate(0 0.765503)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2M);
export default __webpack_public_path__ + "static/media/A2M.4e2bfe38831569a35b5fff56cc0f66cb.svg";
export { ForwardRef as ReactComponent };